export const LIMITED = 'limited'
export const FULL = 'fullContactsNoAccounting'

export const ACCESS_OPTIONS = [
  { value: LIMITED, label: 'Limited (Group Only)' },
  { value: FULL, label: 'Full Contacts' },
]

export const accessOf = (row) => (row?.accessLevel === FULL ? FULL : LIMITED)

export const accessLabel = (value) => ACCESS_OPTIONS.find((option) => option.value === value)?.label || ACCESS_OPTIONS[0].label

export const accessConfirmTitle = (value) => `Change access to "${accessLabel(value)}"?`

export const accessConfirmMessage = (value) => (value === FULL
  ? 'This person will see every client file of the office, without Accounting.'
  : 'This person will see only the client files assigned to them.')

export const accessChangedMessage = (value) => `Access changed to ${accessLabel(value)}`

export const RESET_TITLE = 'Send password reset link'
export const RESET_CONFIRM_TITLE = 'Send a password reset link?'
export const RESET_SENT = 'Password reset link sent'

const fullName = (row) => `${row?.firstName || ''} ${row?.lastName || ''}`.trim()

export const COOWNER_TITLE = 'Make co-owner'

export const coOwnerConfirmTitle = (row) => `Make ${fullName(row)} a co-owner?`

export const coOwnerConfirmLines = (row) => [
  `${fullName(row)} will get the same powers as you in this office: every client file of the office, Accounting, payments, dashboard money, and adding and pausing reps.`,
  'Only VLG can remove a co-owner. You will no longer be able to pause or change this person.',
  `${row?.firstName || 'They'} must sign out and back in to see Accounting.`,
]

export const coOwnerGrantedMessage = (row) => `${fullName(row)} is now a co-owner`

export const resetConfirmMessage = (row) => `We will email a link to ${row?.email}. ${row?.firstName}'s current password keeps working until they use it. The link works once and expires in 24 hours.`
